import FormStatusCreate from './FormStatusCreate';
import FormStatusDelete from './FormStatusDelete';
import FormStatusFilter from './FormStatusFilter';
import FormStatusUpdate from './FormStatusUpdate';

export default Object.assign(
  {},
  {
    Create: FormStatusCreate,
    Update: FormStatusUpdate,
    Delete: FormStatusDelete,
    Filter: FormStatusFilter,
  },
);
